import React, { useMemo } from "react";

// A subtle "warehouse rack" motif for auth brand panels — ties the visual
// to inventory specifically instead of a generic gradient. Generated once
// per mount so it isn't reshuffled on every re-render.
const WarehouseGridMotif: React.FC = () => {
  const cells = useMemo(() => {
    const total = 11 * 13;
    const pulseIdx = new Set<number>();
    while (pulseIdx.size < 3) {
      pulseIdx.add(Math.floor(Math.random() * total));
    }
    return Array.from({ length: total }, (_, i) => {
      if (pulseIdx.has(i)) return "pulse";
      const r = Math.random();
      if (r < 0.14) return "fill2";
      if (r < 0.34) return "fill1";
      return "base";
    });
  }, []);

  return (
    <div
      className="pointer-events-none absolute -inset-x-[10%] -inset-y-[10%] left-[30%] grid grid-cols-11 gap-2 opacity-50"
      style={{
        transform: "rotate(-8deg) scale(1.25)",
        maskImage:
          "linear-gradient(115deg, rgba(0,0,0,0) 5%, rgba(0,0,0,.9) 40%, rgba(0,0,0,0) 82%)",
        WebkitMaskImage:
          "linear-gradient(115deg, rgba(0,0,0,0) 5%, rgba(0,0,0,.9) 40%, rgba(0,0,0,0) 82%)",
      }}
    >
      {cells.map((c, i) => (
        <div
          key={i}
          className={
            "aspect-square rounded-[5px] " +
            (c === "pulse"
              ? "bg-white/60 animate-pulse motion-reduce:animate-none"
              : c === "fill2"
              ? "bg-white/25"
              : c === "fill1"
              ? "bg-white/15"
              : "bg-white/5")
          }
        />
      ))}
    </div>
  );
};

export default WarehouseGridMotif;
